<template>
  <div class="producer-query common-page">
    <a-breadcrumb>
      <a-breadcrumb-item>生产者管理</a-breadcrumb-item>
      <a-breadcrumb-item>查询生产者</a-breadcrumb-item>
    </a-breadcrumb>

    <section class="search-box">
      <a-select
        v-model="producerUserName"
        showSearch
        :showArrow="false"
        allowClear
        size="large"
        placeholder="生产者账号"
        @change="searchSelectChange"
        style="width: 400px"
      >
        <a-select-option
          v-for="producer in producers_select"
          :key="producer.id"
          :value="producer.userName"
          optionFilterProp="label"
        >{{producer.userName}}</a-select-option>
      </a-select>
      <a-button type="primary" size="large" @click="searchSelectChange(producerUserName)">搜索</a-button>
    </section>

    <section class="search-result-number">
      <span>{{ producers.length }}个查询结果</span>
    </section>

    <section>
      <div :key="producer.id" class="common-box" v-for="(producer, index) in producers">
        <div class="common-box-body">
          <div class="common-box-body-title">
            <span>{{ producer.userName }}</span>
            <div>
              <a-button @click="goProducerModify(producer.id)" type="link">修改</a-button>
              <a-divider type="vertical" />
              <a-button @click="goProducerPassword(producer.userName)" type="link">修改密码</a-button>
            </div>
          </div>

          <!-- key:value格式 -->
          <a-row>
            <!-- <a-col :span="8" class="key-value-col">
              <span>生产者ID：</span>
              <span>{{ producer.id }}</span>
            </a-col>-->
            <a-col :span="8" class="key-value-col">
              <span>生产者姓名：</span>
              <span>{{ producer.name }}</span>
            </a-col>
            <a-col :span="8" class="key-value-col">
              <span>公司名称：</span>
              <span>{{ producer.company }}</span>
            </a-col>
            <a-col :span="8" class="key-value-col">
              <span>公司英文名称：</span>
              <span>{{ producer.companyEn }}</span>
            </a-col>
            <a-col :span="8" class="key-value-col">
              <span>是否允许生产：</span>
              <span>{{ producer.enabled?'是':'否' }}</span>
            </a-col>
            <a-col :span="8" class="key-value-col">
              <span>手机号：</span>
              <span>{{ producer.phone }}</span>
            </a-col>
            <a-col :span="8" class="key-value-col">
              <span>地址：</span>
              <span>{{ producer.address }}</span>
            </a-col>
            <a-col :span="8" class="key-value-col">
              <span>描述：</span>
              <span>{{ producer.description }}</span>
            </a-col>
          </a-row>

          <!-- 查看更多信息btn -->
          <a-button
            @click="
              setRelatedProducts(index);
              lookMore(index);
            "
            class="look-more-btn"
            type="link"
          >
            查看更多信息
            <a-icon type="down" />
          </a-button>

          <div class="more-wrapper" style="display:none;">
            <a-divider />

            <!-- 关联的产品table -->
            <span class="table-name">关联的产品</span>
            <a-table
              :columns="columns"
              :dataSource="producer.relatedProducts"
              :pagination="false"
              :rowKey="(record, index) => index"
            >
              <!-- 产品id -->
              <template slot="productid" slot-scope="text">
                <span>{{getProductNameByID(text)}}</span>
              </template>
            </a-table>

            <!-- 收起btn -->
            <a-button @click="packUp(index)" class="pack-up-btn" type="link">
              收起
              <a-icon type="up" />
            </a-button>
          </div>
        </div>
      </div>
    </section>

    <spin v-if="loading"></spin>
  </div>
</template>

<script>
import axios from 'axios'
import {
  queryProducers,
  queryAllRelatedProducts,
  queryProduct
} from '../api/api'

const columns = [
  {
    title: '产品ID',
    dataIndex: 'productid',
    width: '20%',
    scopedSlots: { customRender: 'productid' }
  },
  {
    title: '生产者ID',
    dataIndex: 'produceruserid',
    width: '20%'
  },
  {
    title: '起始编号',
    dataIndex: 'startnumber',
    width: '20%'
  },
  {
    title: '可激活次数',
    dataIndex: 'activablenumber',
    width: '20%'
  },
  {
    title: '串号年份',
    dataIndex: 'year',
    width: '20%'
  }
]

export default {
  name: 'producer-query',

  data() {
    return {
      columns,
      producers: [],
      producers_select: [],
      relatedProducts: [],
      products: [],
      producerUserName: undefined
    }
  },

  created() {
    this.fetchData()
  },

  methods: {
    lookMore(index) {
      document.querySelectorAll('.more-wrapper')[index].style.display = 'block'
      document.querySelectorAll('.look-more-btn')[index].style.display = 'none'
    },

    packUp(index) {
      document.querySelectorAll('.more-wrapper')[index].style.display = 'none'
      document.querySelectorAll('.look-more-btn')[index].style.display = 'block'
    },

    setRelatedProducts(index) {
      let producerID = this.producers[index].id
      let relatedProducts = this.relatedProducts.filter(
        relatedProduct => relatedProduct.produceruserid === producerID
      )
      this.$set(this.producers[index], 'relatedProducts', relatedProducts)
    },

    goProducerModify(producerID) {
      this.$router.push({
        name: 'producer-modify',
        query: {
          producerID
        }
      })
    },

    goProducerPassword(producerUserName) {
      this.$router.push({
        name: 'producer-password',
        query: {
          producerUserName
        }
      })
    },

    fetchData() {
      this.loading = true
      axios
        .all([queryProducers(), queryAllRelatedProducts(), queryProduct()])
        .then(
          axios.spread((res1, res2, res3) => {
            if (res1.error.code === 0) {
              this.producers = res1.response ? res1.response.producers : []

              res1.response.producers.forEach(item => {
                if (item.userName == null && item.phone) {
                  item.userName = item.phone
                }
              }) 

              this.producers_select = res1.response
                ? res1.response.producers
                : []
            }

            if (res2.error.code === 0) {
              this.relatedProducts = res2.response
                ? res2.response.relatedProducts
                : []
            }

            if (res3.error.code === 0) {
              this.products = res3.response.products
            }
            this.loading = false
          })
        )
        .catch(err => {
          this.loading = false
        })
    },

    getProductNameByID(id) {
      let obj = this.products.find(item => item.id === id)
      return obj && obj.name
    },

    // 搜索下拉框change事件
    searchSelectChange(producerUserName) {
      if (producerUserName === undefined) {
        this.producers = this.producers_select
      } else {
        this.producers = this.producers_select.filter(
          producer => producer.userName === producerUserName
        )
      }
    }
  }
}
</script>

<style lang="less" scoped>
.producer-query {
}
</style>